export const QUALIFICATIONS_CATEGORIES = Object.freeze({
  ADVANCE: 'advance',
  GROUPED: 'grouped',
  LAYERED: 'layered',
  NESTED: 'autoNested',
});
